/* Accueil Lune : bloc « Quelle lune » et film. Porté de maquette/index.html (f50cbed). Dépend de jall-lune-calcul.js. */
(function () {
  if (window.JallAccueilPret) return;   // le script est inclus par deux sections (lune, film) : un seul jeu d'écouteurs
  window.JallAccueilPret = true;
  const L = window.JallLune;
  async function lieu(nomLieu, connu) {  // ville -> position et fuseau horaire ; null si introuvable, exception si service injoignable
    // le lieu affiché au chargement a sa position dans les réglages : aucun appel au service sans demande du visiteur
    if (connu && nomLieu.toLowerCase() === connu.nom.toLowerCase()) return connu;
    const { ville, france } = L.decouperLieu(nomLieu);
    let panne = null;
    if (france) {  // communes françaises : API Géo de l'État (geo.api.gouv.fr, ouverte, sans clé)
      try {
        const r = await fetch(`https://geo.api.gouv.fr/communes?fields=nom,centre,codeDepartement,population&boost=population&limit=10&nom=${encodeURIComponent(ville)}`);
        if (!r.ok) throw new Error(`API Géo ${r.status}`);
        const c = L.choisirCommune(await r.json(), ville);
        if (c) return L.communeVersLieu(c);
      } catch (e) { panne = e; }
    }
    // Belgique, Suisse, étranger (ou commune non trouvée) : Photon (photon.komoot.io, données © contributeurs OpenStreetMap)
    try {
      const r = await fetch(`https://photon.komoot.io/api/?limit=1&lang=fr&layer=city&q=${encodeURIComponent(nomLieu)}`);
      if (!r.ok) throw new Error(`Photon ${r.status}`);
      const d = await r.json();
      return d.features && d.features.length ? L.photonVersLieu(d.features[0]) : null;
    } catch (e) { throw panne || e; }
  }
  function initCiel(racine) {
    if (racine.dataset.jallInit) return;   // une seule initialisation par section, même si le script est inclus deux fois
    racine.dataset.jallInit = '1';
    const pos = (racine.dataset.lieuPosition || '').split(',').map(x => x.trim());
    const connu = racine.dataset.lieuDefaut && pos.length >= 3 && !isNaN(+pos[0]) && !isNaN(+pos[1])
      ? { nom: racine.dataset.lieuDefaut, pays: pos[3] || '', fuseau: pos[2], lat: +pos[0], lon: +pos[1] } : null;
    const form = racine.querySelector('form'), champ = racine.querySelector('[type=date]'), champLieu = racine.querySelector('[type=text]');
    const sortie = racine.querySelector('.jall-ciel__resultat'), img = racine.querySelector('.jall-ciel__lune img');
    const cta = racine.querySelector('.jall-ciel__cta'), bouton = form.querySelector('button');
    const phase = n => racine.dataset.phaseUrl.replace('jall-lune-01.webp', `jall-lune-${String(n).padStart(2, '0')}.webp`);
    const aujourdHui = () => new Date().toLocaleDateString('sv-SE');
    champ.max = aujourdHui();
    const message = texte => { sortie.classList.add('jall-ciel__resultat--message'); sortie.textContent = texte; cta.hidden = true; img.classList.add('jall-en-attente'); };
    async function afficher() {
      const iso = champ.value, nomLieu = champLieu.value.trim();
      const m = L.messageSaisie(iso, nomLieu, aujourdHui()); if (m) return message(m);
      sortie.classList.add('jall-ciel__resultat--message'); sortie.textContent = 'Nous cherchons sa lune…'; bouton.setAttribute('aria-busy', 'true');
      let l;
      try { l = await lieu(nomLieu, connu); }
      catch (e) { bouton.removeAttribute('aria-busy'); return message('Nous n’arrivons pas à joindre le service des lieux pour le moment. Réessayez dans un instant.'); }
      bouton.removeAttribute('aria-busy');
      if (!l) return message(`Nous ne trouvons pas « ${nomLieu} ». Essayez le nom de la ville seul, sans code postal, par exemple « Lyon ».`);
      const r = L.lune(L.soirLocal(iso, l.fuseau), l.lat, l.lon);
      const esc = t => String(t).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
      const ou = esc(!l.pays || l.pays === 'France' ? l.nom : `${l.nom} (${l.pays})`);
      sortie.classList.remove('jall-ciel__resultat--message'); img.classList.remove('jall-en-attente');
      sortie.innerHTML = `Le ${L.dateFr(iso)}, au-dessus ${/^[aeiouyhàâéèêëîïôöûüœ]/i.test(l.nom) ? "d'" : 'de '}${ou}, la lune était éclairée à ${Math.round(r.fraction * 100)} % : <em>${L.nom(r.fraction, r.croissante)}</em>.`;
      cta.href = L.lienFiche(racine.dataset.fiche, iso, l.nom); cta.hidden = false;
      const src = phase(r.image), tourner = `rotate(${r.inclinaison}deg)`;
      // asset_url rend une adresse sans « https: » : on compare des adresses absolues
      if (img.src !== new URL(src, location.href).href) { img.classList.add('jall-sortante'); setTimeout(() => { img.style.transform = tourner; img.src = src; img.onload = () => img.classList.remove('jall-sortante'); }, 250); }
      else img.style.transform = tourner;
    }
    form.addEventListener('submit', e => { e.preventDefault(); afficher(); });
    afficher();
  }
  function initFilm(racine) {
    if (racine.dataset.jallInit) return;
    racine.dataset.jallInit = '1';
    racine.querySelectorAll('[data-lire]').forEach(b => b.addEventListener('click', () => {
      if (!racine.dataset.film) return;   // aucun film choisi dans l'éditeur
      const ecran = racine.querySelector('.jall-film__ecran');
      if (ecran.querySelector('video')) return;
      ecran.innerHTML = `<video src="${racine.dataset.film}" controls autoplay playsinline></video>`;
    }));
  }
  function init(portee) {
    portee.querySelectorAll('[data-jall-ciel]').forEach(initCiel);
    portee.querySelectorAll('[data-jall-film]').forEach(initFilm);
  }
  init(document);
  // éditeur de thème : une section modifiée est redessinée puis annoncée par shopify:section:load
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
